import React from "react";
import { FormGroup } from "react-bootstrap";
import Label from "../Label/Label";
import Input from "../Input/Input";
import InputError from "../InputError/InputError";

function FormInput(props) {
  const {
    label,
    error,
    errorClassName,
    id,
    name,
    type,
    className,
    value,
    disabled,
    onChange,
    minLength,
    maxLength,
    checked,
    placeHolder,
    multiple,
    accept,
    readOnly,
  } = props;

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <Input
        id={id}
        name={name}
        type={type}
        className={className}
        value={value}
        disabled={disabled}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        checked={checked}
        placeHolder={placeHolder}
        multiple={multiple}
        accept={accept}
        readOnly={readOnly}
      />
      <InputError error={error} className={errorClassName} />
    </FormGroup>
  );
}

export default FormInput;
